import {
  SignedFile,
  SignedUrlResponse,
} from "@coworker/apprestructured/src/task-management/services/uploads.service";
import { CreateUpload } from "@coworker/apprestructured/src/task-management/types/Upload";

export type UploaderResult = {
  // Images - true if images can be uploaded, meaning:
  //    - all images have been compressed
  //    - signed urls has been fetched for all images
  // Files - true if all files have signed urls
  ready: boolean;

  // Upload the images/files to the bucket
  upload: () => Promise<void>;

  // CreateUpload objects for the images/files
  createUploads: CreateUpload[];
};

export const NO_CREATE_UPLOADS: CreateUpload[] = [];

export function convertToSignedFiles(
  files: File[],
  signedUrlResponses: SignedUrlResponse[]
): SignedFile[] {
  return files.map((file) => {
    const signedUrlResponse = signedUrlResponses.find(
      ({ originalFileName }) => originalFileName === file.name
    )!;
    return { file, signedUrl: signedUrlResponse.signedUrl };
  });
}

export function calcHasSignedUrlsForAllFiles(
  files: File[],
  signedUrlResponses: SignedUrlResponse[]
) {
  return (
    files.length === signedUrlResponses.length &&
    files.every((file) =>
      signedUrlResponses.some(
        (response) => response.originalFileName === file.name
      )
    )
  );
}

/**
 * Convert a list of files into a list of CreateUpload.
 * Each File#name must have a corresponding WriteSignedUrlResponse#originalFileName.
 *
 * @param files the files to convert
 * @param signedUrlResponses signed urls for all files
 */
export function filesToCreateUploads(
  files: File[],
  signedUrlResponses: SignedUrlResponse[]
): CreateUpload[] {
  return files.map((file) => {
    const bucket_id =
      signedUrlResponses.find(
        ({ originalFileName }) => originalFileName === file.name
      )?.fileName || null;

    if (bucket_id === null) {
      throw new Error(`No signed url exists for file '${file.name}'`);
    }

    return {
      name: file.name,
      size: file.size,
      bucket_id,
    };
  });
}
